export enum RolesEnum {
  ADMIN = "ADMIN",
  SUPERADMIN = "SUPERADMIN",
  MEMBER = "MEMBER",
  ACCOUNTANT = "ACCOUNTANT",
  DRIVER = "DRIVER",
  PACKER = "PACKER",
}

export type ClientRole = Exclude<RolesEnum, RolesEnum.DRIVER | RolesEnum.PACKER>;
